/**
 * @description 超連結 Element 連結是否開啟新視窗用
 */
export enum LinkTarget {
  NewWindow = '1',
  SelfWindow = '0'
}
